module.exports = __webpack_public_path__ + "img/pro-five.8442e62a.png";